import { Injectable } from '@angular/core';
import {switchMap, tap} from 'rxjs/operators';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { GlobalComponent } from 'src/app/global-component';
import {BehaviorSubject, Observable} from 'rxjs';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { AuditLogModel } from '../models/security/audit-log.model';
import { BaseListService } from './list-services/base-list.service';
import { AuditLogSearchModel } from '../models/security/audit-log-history.model';

export type SortColumn = keyof AuditLogModel | '';
export type SortDirection = 'asc' | 'desc' | '';

@Injectable({
  providedIn: 'root'
})
export class AuditLogListService extends BaseListService{

  private _resultItems$ = new BehaviorSubject<AuditLogModel[]>([]);

  defaultAuditLogListState: AuditLogSearchModel = {
    sortColumnDirective: 'createdDate',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: '',
    sortDirection: 'desc',
    method: '',
    requestSearchTerm: '',
    responseSearchTerm: '',
    requestUrl: '',
    remoteIPAddress: '',
    event: 0,
    username: undefined,
    searchTerm: undefined
  };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result:any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }

  get event() { return this._state.event; }

  set userName(username:string|undefined){ this._state.username = username;}

  set event(event: any) { this._set({event}); } 


  protected _search() :  Observable<SearchResultModel<AuditLogModel>> {   

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getAuditLogs(this._state);
  }

  override clearListService(): void {
    this._state = {...this.defaultAuditLogListState};
    this._resultItems$.next(new Array<AuditLogModel>());
    this._total$.next(0);
  }

}
